/**
 * `customAttributes` is selected at the top level. The identical field under `attributes` is
 * deprecated in the UPS schema in favour of this one.
 */
export const unifiedProductQuery = `
query UnifiedProduct($productUri: String!) {
  product(by: { uri: $productUri }) {
    attributes {
      highlyRated
      starBrand
    }
    customAttributes {
      key
      value {
        ... on StringValue {
          value
        }
        ... on NumberValue {
          numValue: value
        }
        ... on BooleanValue {
          boolValue: value
        }
        ... on ArrayValue {
          values
        }
      }
      attributeType
    }
  }
}
`;
